/**
 * SP では data-collapsed-on-sp の details を初期閉じのままにし、
 * PC（769px以上）では市区グリッドを常に表示するため open を付与する。
 */
export default function blockAreaSearch() {
    const mq = window.matchMedia("(min-width: 769px)");

    const sync = () => {
        document.querySelectorAll(".c-blocks-area-search-parts[data-collapsed-on-sp]").forEach((el) => {
            if (mq.matches) {
                el.setAttribute("open", "");
            } else {
                el.removeAttribute("open");
            }
        });
    };

    sync();
    mq.addEventListener("change", sync);

    const summaries = document.querySelectorAll(".c-blocks-area-search-parts__summary");

    const updateSummaryBehavior = () => {
        summaries.forEach((summary) => {
            if (mq.matches) {
                summary.style.pointerEvents = "none";
                const checkbox = summary.querySelector("input[type='checkbox']");
                if (checkbox) {
                    checkbox.style.pointerEvents = "auto";
                }
                const label = summary.querySelector(".c-forms-checkbox");
                if (label) {
                    label.style.pointerEvents = "auto";
                }
            } else {
                summary.style.pointerEvents = "";
                const checkbox = summary.querySelector("input[type='checkbox']");
                if (checkbox) checkbox.style.pointerEvents = "";
                const label = summary.querySelector(".c-forms-checkbox");
                if (label) label.style.pointerEvents = "";
            }
        });
    };

    updateSummaryBehavior();
    mq.addEventListener("change", updateSummaryBehavior);

    summaries.forEach((summary) => {
        summary.addEventListener("click", (e) => {
            if (!mq.matches) {
                // SP: チェックボックスクリック時は開閉しない
                if (e.target === summary.querySelector("input[type='checkbox']") || e.target.closest(".c-forms-checkbox")) {
                    e.preventDefault();
                    const checkbox = summary.querySelector("input[type='checkbox']");
                    if (checkbox) checkbox.checked = !checkbox.checked;
                }
            }
        });
    });
}
